import React, { useEffect, useState } from "react";
import { API } from "../../../http-common";
import { useParams } from "react-router-dom";
import { Button } from "reactstrap";
import { Container } from "react-bootstrap";
import { useSnackbar } from 'react-simple-snackbar'
import "./SubDocument.css";

const optionsError = {
  position: 'bottom-right',
  style: {
      backgroundColor: 'var(--bs-red)',
      border: '0',
      color: '#fff',
      fontSize: '20px',
      textAlign: 'center',
      marginBottom: '5rem',
      position: 'fixed',
      zIndex: "99"
  },
  closeStyle: {
      color: '#fff',
      fontSize: '16px',
      marginRight: '1rem',
  },
}

const ACTION_MESSAGES = {
  completed: 'Gracias por firmar el documento',
  cancel: 'Usted ha salido de la sesión de firma. Recuerde que el documento aún no quedó firmado. Vuelva a ingresar a la plataforma para finalizar el proceso.',
}

const SubDocument = () => {
  const { hash } = useParams();
  const [pdfUrl, setPdfUrl] = useState("");
  const [signUrl, setSignUrl] = useState("");

  const [openSnackbarError] = useSnackbar(optionsError)

  const action = new URLSearchParams(window.location.search).get('action');

  useEffect(() => {
    if (action) {
      return;
    }

    (async () => {
      await API.get(`prospects/sub-prospects/documents/link/${hash}`)
        .then((res) => {
          setPdfUrl(res.data.data.url);
          setSignUrl(res.data.data.signUrl);
        })
        .catch(() => {
          openSnackbarError(`Ocurrio un error por favor contacte con el equipo de soporte`);
        });
    })();
  }, [hash, action]);

  if (action) {
    return (
      <>
        <div className="headerModal d-flex align-items-center justify-content-center mb-5" style={{color:"white", fontSize:"40px",textAlign:"center", fontWeight:"bold"}}>BALANZ-IFA DOCUMENTO</div>
        <Container>
          <div className="message-info">
            <p className='my-3 text-center'>
              {ACTION_MESSAGES[action] || 'Gracias'}
            </p>
          </div>
        </Container>
      </>
    );
  }

  return (
    <>
      <div className="headerModal d-flex align-items-center justify-content-center mb-5" style={{color:"white", fontSize:"40px",textAlign:"center", fontWeight:"bold"}}>BALANZ-IFA DOCUMENTO</div>
      <div className="agreementButtons">
        {signUrl && <Button href={signUrl} className='my-2 mb-5' variant="success">FIRMAR DOCUMENTO</Button>}
      </div>
      <div className="pdfContainer">
        {pdfUrl && (
          <iframe
            src={pdfUrl + "#toolbar=0"}
            className="pdfViewer"
          ></iframe>
        )}
      </div>
    </>
  );
};

export default SubDocument;
